import TextArea from 'semantic-ui-react/dist/commonjs/addons/TextArea';

export default TextArea;
